import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styles from './RichTextEditor.module.css';

const modules = {
  toolbar: [
    [{ 'header': [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'blockquote'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'align': [] }],
    ['link', 'image'],
    ['code-block'],
    ['clean']
  ],
  syntax: {
    highlight: (text) => {
      // Basic syntax highlighting for common languages
      return text;
    }
  }
};

const formats = [
  'header', 'bold', 'italic', 'underline', 'blockquote',
  'list', 'bullet', 'align', 'link', 'image', 'code-block'
];

const RichTextEditor = ({ value, onChange, placeholder }) => {
  // Detect RTL (Arabic) for direction
  const isRTL = /[\u0600-\u06FF]/.test(value);
  return (
    <div className="border border-pink-200 rounded-2xl overflow-hidden shadow-lg bg-white">
      <ReactQuill
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
        theme="snow"
        style={{ minHeight: 250, direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}
        className={styles.quill}
      />
      <div className="bg-gray-50 px-4 sm:px-6 py-2 sm:py-3 border-t border-pink-200 text-xs sm:text-sm text-gray-500 flex flex-col sm:flex-row sm:justify-between space-y-1 sm:space-y-0">
        <span>{value.replace(/<[^>]*>/g, '').length} characters</span>
        <span>{value.replace(/<[^>]*>/g, '').trim().split(/\s+/).filter(word => word.length > 0).length} words</span>
      </div>
    </div>
  );
};

export default RichTextEditor; 